import { api } from '@/shared/api/client';

export interface PendingActionItem {
  id: number;
  title: string;
  detail: string;
}

export type PendingActionKind =
  | 'aprobar-ausencias'
  | 'firmar-formulario'
  | 'registrar-formulario'
  | 'leer-politicas'
  | 'terminar-cursos'
  | 'verificar-hijos';

export interface PendingActionGroup {
  kind: PendingActionKind;
  title: string;
  /** What happens if nobody does it. Not a description of the screen. */
  consequence: string;
  total: number;
  /** At most five, as a preview. `total` is the honest count. */
  items: PendingActionItem[];
}

export interface PendingActions {
  groups: PendingActionGroup[];
  total: number;
}

export function fetchPendingActions(signal?: AbortSignal): Promise<PendingActions> {
  return api.get<PendingActions>('/pendientes', { signal });
}
